<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">展会介绍</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">展会总览</el-menu-item>
            <el-menu-item index="2" v-if="false">组织机构</el-menu-item>
            <el-menu-item index="3">主办单位</el-menu-item>
            <!-- <el-menu-item index="7">展会历程</el-menu-item> -->
            <!-- <el-menu-item index="4">展会光荣榜</el-menu-item> -->
            <el-menu-item index="5">展馆导览</el-menu-item>
            <el-menu-item index="6">展会声明</el-menu-item>
          </el-menu>
          <!-- 相关文章 -->
          <!-- <div>
            <div style="font-size: 24px;color: #2D67B6;letter-spacing: 0;line-height: 22px;font-weight: 600;margin-top:25px;padding-bottom:15px;border-bottom: 3px #1D50A2 solid ;">相关文章</div>
            <div v-for="(item,index) in list" :key='index' @click="xzwzhandle(item)" class="xgtitle">
              {{item.title}}
            </div>
            <div class="address">
              主办单位：中国环境保护产业协会<br />
              地址：北京中国国际展览中心
              （朝阳馆）<br />
              日期：2026年6月2日-4日
            </div>
          </div> -->
          <!-- 展出时间 -->
          <div class="zcsj">
            展出时间
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月2日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月3日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月4日 9:00-16:00
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              （每日闭馆前1小时停止入场）
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>></a>
            </div>
            <div>展会介绍>></div>
            <div>{{menuName}}</div>
          </div>
          <div v-if="menuName=='展会总览'||pageNum==1">
            <img style="width:100%" src="../../assets/index/展会介绍.jpg" alt="">
          </div>
          <div style="padding:0 30px" v-if="menuName=='组织机构'||pageNum==2">
            <!-- <h3>一、支持单位</h3> -->
            <!-- <div class="dwname">生态环境部<br /> -->
              <!-- 北京市人民政府</div> -->
            <h3>一、主办单位</h3>
            <div class="dwname">中国环境保护产业协会</div>
            <!-- <h3>三、协办单位</h3> -->
            <!-- <h3>1．政府机构</h3> -->
            <!-- <div class="dwname">商务部外贸发展事务局<br />
              香港特别行政区政府环境保护署<br />
              澳门特别行政区政府环境保护局<br />
              韩国环境部<br />
              大韩贸易投资振兴公社<br />
              挪威创新署<br />
              挪威驻华大使馆商务处<br />
              意大利对外贸易委员会北京办事处<br />
              英国驻华大使馆商业贸易部<br />
              加拿大驻华大使馆商务处<br />
              美国驻华大使馆商务处</div>
            <h3>2．生态环境部直属单位</h3>
            <div class="dwname">中国环境科学研究院<br />
              中国环境监测总站<br />
              生态环境部环境发展中心<br />
              生态环境部环境与经济政策研究中心<br />
              中国环境报社<br />
              生态环境部对外合作与交流中心<br />
              生态环境部南京环境科学研究所<br />
              生态环境部华南环境科学研究所<br />
              生态环境部环境规划院<br />
              生态环境部环境工程评估中心<br />
              生态环境部卫星环境应用中心<br />
              生态环境部固体废物与化学品管理技术中心<br />
              生态环境部土壤与农业农村生态环境监管技术中心<br />
              生态环境部宣传教育中心<br />
              中华环境保护基金会<br />
              中国生态文明研究与促进会<br />
            </div>
            <h3>3．行业机构</h3>
            <div class="dwname">中国石油和化学工业联合会<br />
              中国建筑材料联合会<br />
              中国钢铁工业协会<br />
              中国矿业联合会<br />
              中国对外承包工程商会<br />
              中国再生资源回收利用协会<br />
              中国化工环保协会<br />
              中国炼焦行业协会<br />
              中国畜牧业协会<br />
              中国表面工程协会<br />
              中国铸造协会<br />
              中国产业海外发展协会<br />
              中国中小商业企业协会<br />
              中国硅酸盐学会<br />
              中国建设教育协会<br />
              中国环保机械行业协会<br />
              中国电力企业联合会<br />
              中国核工业勘查设计协会<br />
              中国木材保护工业协会<br />
              中国报关协会<br />
              中国健康管理协会<br />
              中国电子节能技术协会<br />
              韩国环境产业协会<br />
              挪威能源与环境协会<br />
            </div>
            <h3>4．地方协会</h3>
            <div class="dwname">北京市环境保护产业协会<br />
              天津市环境保护产业协会<br />
              河北省环境保护产业协会<br />
              山西省环境保护产业协会<br />
              内蒙古自治区环境保护产业协会<br />
              辽宁省环境保护产业协会<br />
              吉林省环境保护产业协会<br />
              黑龙江省生态环境保护产业协会<br />
              上海市环境保护产业协会<br />
              江苏省环境保护产业协会<br />
              浙江省环保产业协会<br />
              安徽省环境保护产业发展促进会<br />
              福建省环境保护产业协会<br />
              江西省环境保护产业协会<br />
              山东省环境保护产业协<br />
              河南省环境保护产业协b<br />
              湖北省环境保护产业协会<br />
              湖南省环境保护产业协会<br />
              广东省环境保护产业协会<br />
              广西壮族自治区环境保护产业协会<br />
              重庆市环境保护产业协会<br />
              四川省环境保护产业协会<br />
              贵州省环境保护产业协会<br />
              云南省环境保护产业协会<br />
              陕西省环境保护产业协会<br />
              甘肃省环境保护产业协会<br />
              青海省环境保护产业协会<br />
              宁夏环境保护产业协会<br />
              新疆维吾尔自治区生态环境保护产业协会<br />
              新疆生产建设兵团环境保护产业协会<br />
              广州环境保护产业协会<br />
              武汉环境保护产业协会<br />
              哈尔滨市环境保护产业协会<br />
              沈阳环境保护产业协会<br />
              成都市环境保护产业协会<br />
              南京环境保护产业协会<br />
              西安市环境保护产业协会<br />
              长春市环境保护产业协会<br />
              杭州市环保产业协会<br />
              深圳市环境保护产业协会<br />
              厦门市环境保护产业协会<br />
              宁波市环境保护产业协会<br />
              青岛市环境保护产业协会<br />
              大连市环境保护产业协会<br />
              呼和浩特市环境保护产业协会<br />
              苏州市环保产业协会<br />
              常州市环境保护产业协会<br />
              泰州市环境保护产业协会<br />
              南通市环境保护产业协会<br />
              白银市环境保护产业协会<br />
              宜兴市环保产业协会<br />
              绵阳市生态环境产业协会<br />
              佛山市环境保护产业协会<br />
              廊坊市环境保护产业协会<br />
              三门峡市环境保护产业协会<br />
              宜兴市绿色低碳产业协会<br />
              国家环境服务业华南集聚区<br />
              江苏盐城环保科技城<br />
            </div> -->
          </div>
          <div v-if="menuName=='主办单位'||pageNum==3">
            <h2>中国环境保护产业协会简介</h2>
            <img style="width:95%; margin:0 40px" src="../../assets/index/zgcyxhzp.jpg" alt="">
            <div class="zhzl">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国环境保护产业协会（以下简称协会）成立于1984年，是由从事生态环境相关的生产、服务、研发、管理等活动的企事业单位、社会组织及个人自愿结成的5A级全国性、行业性社会团体，登记管理机关是民政部，党建工作机构是中央和国家机关工作委员会，行业管理部门是生态环境部，与全国各省（区、市）环境保护产业协会共同服务数万家环保企业。<br />

              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;协会在中央和国家机关工作委员会、国家发展和改革委员会、科学技术部、工业和信息化部、民政部、生态环境部等部委的支持和指导下，以推动生态环保产业高质量发展、服务国家生态文明建设为己任，以“服务国家、服务社会、服务企业、服务行业”为宗旨，努力发挥桥梁纽带作用，维护会员权益，反映行业诉求，推进行业自律，广泛开展“十送”服务，为会员提供环保产业政策、法律法规、标准、技术、信息、金融、产品和服务认证、信用评价、人员培训、会展推广、国际交流合作等服务。
            </div>
          </div>
          <!-- <div style="padding:20px 30px" v-if="menuName=='展会光荣榜'||pageNum==4">
            <img style="width:100%" src="../../assets/index/zhgrb.jpg" alt="">
          </div> -->
          <div style="padding:0 30px" v-if="menuName=='展馆导览'||pageNum==5">
            <img height="900px" style="width:100%" src="../../assets/index/1.jpg" alt="">
            <img height="1200px" style="width:100%" src="../../assets/index/2.jpg" alt="">
          </div>
          <div style="padding:0 20px" v-if="menuName=='展会声明'||pageNum==6">
            <div class="zhzl">
              中国国际环保展览会唯一主办方为“中国环境保护产业协会”；<br />

              中国环境保护产业协会官方网站为“www.caepi.org.cn”；<br />

              中国国际环保展览会官方网站为“www.ciepec.org”；<br />

              展会官方报名与咨询电话：010-52806519；<br />

              中国国际环保展览会官方微信号：“中国国际环保展CIEPEC”；<br />

              中国国际环保展览会官方微信群：“中国国际环保展览会展商服务群1群”“中国国际环保展览会展商服务群2群”<br />

              如有问题，请联系：010-52806519。<br />
            </div>
          </div>
          <div v-if="menuName=='展会历程'||pageNum==7">
            <div class="zhlc">
              <span style="color:#c0392b;font-weight:600">1986年：</span>为了推动环保技术交流与合作，促进环保产业发展，在原国家环境保护局等单位的共同推动下，第一届“国际环境保护技术装备展览会”于1986年在北京展览馆举办。本届展会也是新中国成立后第一场大型国际环保展会。<br />
              <span style="color:#c0392b;font-weight:600">1992年</span>：国务院环境保护委员会委托国家环境保护局召开了第一次全国环境保护产业工作会议。会议同期举办了“第一届全国环保产业展览会”，与“国际环境保护技术装备展览会”同期举办，展会名称变更为“首届中国环保产业暨第三届国际环保展览会”，英文名称定为“CEPEC”。曲格平先生为展会题词。<br />
              <span style="color:#c0392b;font-weight:600">1995年：</span>展期由三年一届改为两年一届，并形成了由国家环境保护局主办，中国环境保护产业协会承办，各有关工业部委局、总公司等联合支持的品牌展会。<br />
              <span style="color:#c0392b;font-weight:600">1999年：</span>本届展会作为当时中国最大规模国际环保展，展示二十世纪环保产业发展水平，表达将绿色带入二十一世纪的决心，时任中共中央政治局委员、北京市委书记贾庆林，全国人大副委员长邹家华，全国人大环资委主任曲格平，国家环保总局局长解振华，韩国环境部长林淑女士等出席展会开幕式。<br />
              <span style="color:#c0392b;font-weight:600">2001年：</span>展会落户中国国际展览中心（静安庄馆）。CIEPEC2001在展出规模上、展商水平和观众数量上都发生了质的飞跃。<br />
              <span style="color:#c0392b;font-weight:600">2003年：</span>展会名称变更为中国国际环保展览暨会议。<br />
              <span style="color:#c0392b;font-weight:600">2007年：</span>国务院副总理曾培炎为展会发来贺信，勉励展会“围绕节能减排和推进环保产业技术进步的主题，开展多层次国际环境技术交流与合作，推进环保产业发展，为实现经济社会又快又好发展做出积极贡献”。<br />
              <span style="color:#c0392b;font-weight:600">2009年：</span>第十一届中国国际环保展览暨会议（CIEPEC2009），由原环境保护部、国家发展和改革委员会、科学技术部、工业和信息化部、住房和城乡建设部、北京市人民政府六部门共同主办。中国环境保护产业协会独家承办。<br />
              <span style="color:#c0392b;font-weight:600">2011年：</span>中国环境保护产业协会成为主办单位，原环境保护部、国家发改委、科技部、工信部、住建部和北京市人民政府六部门作为支持单位。展会更名为“中国国际环保展览会”，与“十一五环保成就展”同期举办。时任副总理李克强参观展会。<br />
              <span style="color:#c0392b;font-weight:600">2017年：</span>推出全新“环保产业创新发展大会”品牌。设主论坛和二十场分论坛，吸引了现场参会者4500余名以及逾万名环保人的在线关注。<br />
              <span style="color:#c0392b;font-weight:600">2018年：</span>展会首次双年举办，自此展期变更为一年一届。展会推出“绿动CIEPEC”系列活动，开始打造绿色会展品牌，践行社会责任，让环保展更环保。<br />
              <span style="color:#c0392b;font-weight:600">2019年：</span>展会以“打好污染防治攻坚战”为主题，汇集国内外众多知名企业参展。环保产业创新发展大会参会人数超过6000人次。<br />
              <span style="color:#c0392b;font-weight:600">2020年：</span>受疫情影响，改为线上展览。自此，CIEPEC开启“双线融合”的展览模式，为环保企业提供长效展示对接平台。<br />
              <span style="color:#c0392b;font-weight:600">2021年：</span>以红色为主旋律，绿色为主基调，以展会35周年为契机，成功献礼建党百年。曲格平先生为展会再度题词“发展绿色产业”，陈昌智副委员长和解振华特使向大会发来贺信。<br />
              <span style="color:#c0392b;font-weight:600">2023年：</span>在生态环境部和北京市人民政府指导，国家发展改革委、工信部、科技部、商务部等政府部门支持，行业商协会等80余家单位积极参与和大力协助下，第二十一届中国国际环保展览会（CIEPEC2023）和第五届生态环保产业创新发展大会于2023年4月13日至15日在北京圆满举办，共计超过800多家展商、100余家知名科研院所同台亮相。观众人数超过10万人次。<br />
              <span style="color:#c0392b;font-weight:600">2024年：</span>逢中国环境保护产业协会40周年之际，本届展会共有19个国内外展团精彩亮相，并首次正式设立主宾省，成功邀请湖北、辽宁、江苏和天津四地作为主宾省（市）组团参展。展会特设生态环保产业40年成果展专区、生态环保科研成果展区、生态环境科技创新成果展区等十个专区，全面展示最新技术成果和实践应用案例。第六届生态环保产业创新发展大会以“推动科技创新培育新质生产力，加快构建现代化环保产业体系”为主题，整合30余场国内外交流活动。来自“政产学研用”各界的超过5000位嘉宾代表参加各项专题活动。<br />
              <span style="color:#c0392b;font-weight:600">2025年：</span>第二十三届中国国际环保展览会（CIEPEC2025）以“坚持‘两山’理念，服务‘双碳’战略，加快创新发展，促进合作共赢”为主题，同期举办第七届生态环保产业创新发展大会等近40场活动。中国气候变化事务特使刘振民、生态环境部副部长李高、全国政协人口资源环境委员会副主任翟青等领导，院士及14个省市区政府领导，各地生态环境厅（局）、生态环境部各司办及直属单位、新加坡国家环境局、外国驻华使领馆及30余家全国性行业协会的嘉宾莅临参观参会。<br />
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  // props: {
  //   data: String,
  //   nametitle: String
  // },
  props: ['data', 'nametitle'],
  watch: {
    // 监听 data 的变化
    data (newValue, oldValue) {
      this.pageNum = newValue
    },
    nametitle (newValue, oldValue) {
      this.menuName = newValue
    }
  },
  name: 'Gyzh',
  data () {
    return {
      menuName: '展会总览',
      pageNum: '1',
      list: [{
        images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/1.jpg',
        title: '关于邀请参加第二十二届中国国际环保展览会和2024生态环保产业创新发展大会的函',
        content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/2.png',
        time: '2023-09-06',
        type: 'image',
        abstract: '关于邀请参加第二十二届中国国际环保展览会和2024生态环保产业创新发展大会的函'
      }]
    }
  },
  beforeDestroy () {
    // this.pageNum = '1'
    // this.menuName = '展会总览'

  },
  destroyed () {

  },
  mounted () {
    if (this.data) {
      this.pageNum = this.data
      this.menuName = this.nametitle
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      console.log(key)
      window.translate.execute()
    },
    xzwzhandle (item) {
      // this.$router.push({ path: '/caidan/xwzx', query: { pageNum: 'xq', wzcont: item } })
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 0;
  padding-bottom: 27.87%;
  margin-bottom: 60px;
}
.midbgi {
  background-image: none;
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.zhzl {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 45px;
}
.zhlc {
  font-size: 18px;
  font-weight: normal;
  margin: 10px 30px;
  line-height: 40px;
}
h2 {
  text-align: center;
}

.dwname {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/gyzh.vue